// extracted by mini-css-extract-plugin
module.exports = {"text":"text_text__dE229"};